export default {
  computed: {
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    tempData() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex];
    },
  },
  methods: {
    loadNew3DAssets() {
      return new Promise((resolve,reject) => {
        if(this.$recipe.checkForUGC()) {
          const ugcComponents = this.$store.getters['ugc/getUGCEnabledComponents'].filter(componentName =>
            !!this.$recipe.getUGCFeatureType(componentName)
          );

          if (!ugcComponents.length) {
            resolve({ url: null, size: null });
          } else {
            const defaultComponent = this.$store.state.utils.pdm.default_component;
            let secondaryComponent = null;

            if (
              ugcComponents.length > 1
              && ugcComponents.includes(defaultComponent)
              && this.$recipe.getUGCFeatureType(defaultComponent) !== 'ugc'
            ) { // If defaultComponent is not UGC feature type and there is other component with UGC, then load secondary UGC component
              secondaryComponent = ugcComponents.find(name => name !== defaultComponent && this.$recipe.getUGCFeatureType(name) === 'ugc');
            }

            const componentName = ugcComponents.includes(defaultComponent) ? defaultComponent : ugcComponents[0];
            const recipeObj = this.recipe_v2.components[secondaryComponent || componentName];
            const componentType = this.$recipe.getUGCFeatureType(componentName);
            if (componentType === 'imageLibrary') this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", componentType);

            this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_COMPONENT", componentName);
            this.$store.commit("ugc/tempData/SET_UGC_SIZE", recipeObj.ugc.size);
            this.$store.dispatch("ugc/SAVE_ASSETS_3D", componentName).then(() =>
              this.$nextTick(() => resolve(this.tempData.responses.assets3d[componentName].model))
            );
          }
        } else {
          resolve({ url: null, size: null });
        }
      });
    },
    load3Dmodel({size, originalModel}) {
      const bucketURL = this.$store.state.endPoints.customizer.s3ModelsBucket;
      const defaultSize = this.$store.state.utils.bucketSizes[this.pdm.ugcDefaultSize];
      const sizeToLoad = size ? size : defaultSize;
      const modelSKU = this.pdm.parent_model ? this.pdm.parent_model : this.pdm.sku;
      const newModelURL = this.$store.getters["utils/addCacheBusting"](`${bucketURL}gltf_models/${modelSKU}/${sizeToLoad}/${modelSKU}-${sizeToLoad}.glb`);
      const modelUrl = newModelURL;
      return new Promise((resolve, reject) => {
        this.$model3D.loadObject(modelUrl).then((modelObj) => {
          this.$model3D.sceneHelpers.removeModelBySize({sku: originalModel || this.pdm.sku, modelObj: this.$model3D.modelObj, sizeToLoad});
          this.$model3D.setProperty({ property: 'modelObj', value: modelObj.children[0] });
          this.$model3D.setSubProperty({ property: 'modelObj', subproperty: 'name', value: `${modelSKU}-${size ? size : sizeToLoad}` });
          this.$model3D.sceneHelpers.setModelName({ modelSKU });
          this.$store.commit('sceneSetup/SET_LOADED_MODEL_NAME', this.$model3D.modelObj.name);
          this.$store.commit('sceneSetup/SET_MODEL_BY_SIZE', sizeToLoad);
          this.$model3D.sceneHelpers.modelBySize.push(sizeToLoad);
          resolve(modelObj);
        }).catch(reject);
      });
    },
    returnModelSize() {
      let size;
      const defaultSize = this.pdm.ugcDefaultSize;
      const bucketSizeMap = this.$store.state.utils.bucketSizes;
      if(!this.$recipe.checkForUGC()) {
        size = bucketSizeMap[defaultSize];
      } else {
        const currentComponent = this.$recipe.getUGCComponents();
        if(ugcComponents) {
          size = bucketSizeMap[this.recipe_v2.components[ugcComponents[0]].ugc.size];
        }
      }

      if(size !== bucketSizeMap[defaultSize]) {
        return size
      } else {
        return bucketSizeMap[defaultSize];
      }
    }
  }
};
